import { LngLat, LngLatBounds } from 'mapbox-gl'

export function placeWithinSearchRadius(longitude: number, latitude: number): boolean {
  const searchBounds = window.store?.getState().searchBounds

  if (!searchBounds) {
    return true
  }

  const bounds = new LngLatBounds(searchBounds?.toArray())

  return bounds.contains(new LngLat(longitude, latitude))
}
